import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => {
  return {
    modal: {
      position: "fixed",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      zIndex: 1000,
      width: "688px",
      maxWidth: "calc(100% - 32px)",
      maxHeight: "calc(100vh - 32px)",
      borderRadius: "12px",
      background: theme.palette.background.paper,
      boxShadow: "0px 8px 24px -4px rgba(16, 24, 40, 0.15), 0px 8px 16px -4px rgba(16, 24, 40, 0.10)",
      overflowY: "auto",
      display: "flex",
      flexDirection: "column",
      "& p": {
        color: theme.palette.text.tertiary,
        fontWeight: 400,
        fontSize: "16px",
        margin: "4px 0 0",
        [theme.breakpoints.down("sm")]: {
          fontSize: "14px",
        },
      },
      [theme.breakpoints.down("sm")]: {
        width: "100%",
        maxWidth: "100%",
        maxHeight: "100vh",
        borderRadius: 0,
        top: 0,
        left: 0,
        transform: "none",
      },
    },
    header: {
      padding: "24px 24px 0px 24px",
      display: "flex",
      flexDirection: "column",
    },
    containerTitlePlusBackIcon: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
    },
    mainTitle: {
      fontSize: "18px",
      fontWeight: 600,
      color: theme.palette.text.primary,
      lineHeight: "28px",
    },
    subTitle: {
      fontSize: "14px",
      fontWeight: 400,
      color: theme.palette.text.tertiary,
      lineHeight: "20px",
    },
    wrapperContent: {
      padding: "20px 24px",
      overflowY: "auto",
      flex: 1,
    },
    containerFormAddFinancePlan: {
      display: "flex",
      flexDirection: "column",
      gap: "16px",
      maxWidth: "100% !important",
    },
    containerInputSection: {
      display: "flex",
      flexDirection: "row",
      gap: "16px 32px",
      [theme.breakpoints.down("xs")]: {
        flexDirection: "column",
        width: "90vw",
      },
    },
    titleFiled: {
      fontSize: "14px",
      fontWeight: 500,
      lineHeight: "24px",
      color: theme.palette.text.secondary,
      maxWidth: "280px",
      minWidth: "160px",
    },
    footerActions: {
      display: "flex",
      gap: "12px",
      alignItems: "center",
      justifyContent: "flex-end",
      paddingTop: "24px",
      [theme.breakpoints.down("sm")]: {
        marginBottom: "80px",
      },
    },
    autocompleteWidthOverride: {
      width: "100% !important",
    },
    containerCustomInput: { maxWidth: "100%" },
  };
});
